"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formField = _interopRequireDefault(require("@ingka/form-field"));

var _inputField = _interopRequireDefault(require("@ingka/input-field"));

var _propTypes = require("prop-types");

var _tools = require("./utils/tools");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getGroups = num => {
  let {
    0: main,
    1: decimal
  } = num.toString().split('.');
  return {
    main,
    decimal
  };
};

const inputSizeClass = {
  small: '',
  medium: '--m',
  large: '--l'
};

const getIndexFromID = id => {
  const result = /__rangeInput(?<id>\d+)$/.exec(id);
  if (result) return result.groups.id;
};

const SliderInputControls = _ref => {
  let {
    baseClass,
    prefix,
    baseId,
    values,
    validationMessages,
    inputSize,
    prefixLabel,
    suffixLabel,
    range,
    step,
    validation,
    format,
    labels,
    onInput,
    onFocus,
    onBlur,
    ...otherProps
  } = _ref;
  const [focusedFields, setFocusedFields] = (0, _react.useState)([false, false]);
  const [rawValues, setRawValues] = (0, _react.useState)(values || []);
  (0, _react.useEffect)(() => {
    setRawValues([...values]);
  }, [values]);
  inputSize = (0, _react.useMemo)(() => {
    if (inputSize === 'auto') {
      const digits = getGroups(range.max).main.length;
      const decimals = step % 1 !== 0 ? (getGroups(step).decimal || '').length : 0;
      let formattedMaxLength = Math.max(format.to(range.max).length, format.to(range.min).length, format.to(range.max + step).length);
      let metaLength = 0;
      if (prefixLabel.length) metaLength += prefixLabel.length + 1;
      if (suffixLabel.length) metaLength += suffixLabel.length + 1;
      const total = Math.max(digits + decimals, formattedMaxLength) + metaLength;
      inputSize = 'large';
      if (total < 7) inputSize = 'small';else if (total < 9) inputSize = 'medium';
    }

    return inputSize;
  }, [inputSize, prefixLabel, suffixLabel, step, range, format]);
  const inputClasses = (0, _classnames.default)(`${baseClass}__input`, `${baseClass}__input${inputSizeClass[inputSize]}`);

  const inputChange = e => {
    const {
      id,
      value
    } = e.target;
    const inputID = getIndexFromID(id);

    if (focusedFields[inputID]) {
      setRawValues(val => {
        let newval = [...val];
        newval[inputID] = value;
        return newval;
      });
    }

    const newValues = [...values];
    newValues[inputID] = format.from(e.target.value);
    onInput(e, newValues);
  };

  const focusHandler = e => {
    const inputID = getIndexFromID(e.target.id);
    const rawValue = e.target.value;
    const focused = e.type === 'focus';
    let newState = [...focusedFields];
    newState[inputID] = focused;
    setFocusedFields(newState);

    if (!focused) {
      setRawValues(rawval => {
        let newraw = [...rawval];
        newraw[inputID] = rawValue;
        return newraw;
      });
    }
  };

  return _react.default.createElement("div", {
    className: `${baseClass}__input-controls`
  }, _react.default.createElement("div", {
    className: `${baseClass}__input-fields`
  }, values.map((value, index) => {
    return _react.default.createElement(_formField.default, {
      className: `${baseClass}__input-form-field`,
      prefix: prefix,
      shouldValidate: !!validationMessages[index],
      valid: !validationMessages[index]
    }, _react.default.createElement(_inputField.default, _extends({}, otherProps, {
      onFocus: (0, _tools.elx)(onFocus, focusHandler),
      onBlur: (0, _tools.elx)(onBlur, focusHandler),
      id: `${baseId}__rangeInput${index}`,
      type: "number",
      prefix: prefix,
      prefixLabel: prefixLabel,
      label: labels[index] || undefined,
      suffixLabel: suffixLabel,
      onInput: inputChange,
      className: inputClasses,
      "aria-label": `${prefixLabel}${value}${suffixLabel}`,
      value: focusedFields[index] ? rawValues[index] : format.to(value)
    })));
  })));
};

SliderInputControls.defaultProps = {
  labels: []
};
var _default = SliderInputControls;
exports.default = _default;